import Auth from './AuthContainer'

export default Auth
